import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-268d5021"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "player-container" }
const _hoisted_2 = {
  key: 0,
  class: "play-icon"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M37.875 71.25L71.25 50L37.875 28.75V71.25ZM50 100C43.1667 100 36.7083 98.6875 30.625 96.0625C24.5417 93.4375 19.2292 89.8542 14.6875 85.3125C10.1458 80.7708 6.5625 75.4583 3.9375 69.375C1.3125 63.2917 0 56.8333 0 50C0 43.0833 1.3125 36.5833 3.9375 30.5C6.5625 24.4167 10.1458 19.125 14.6875 14.625C19.2292 10.125 24.5417 6.5625 30.625 3.9375C36.7083 1.3125 43.1667 0 50 0C56.9167 0 63.4167 1.3125 69.5 3.9375C75.5833 6.5625 80.875 10.125 85.375 14.625C89.875 19.125 93.4375 24.4167 96.0625 30.5C98.6875 36.5833 100 43.0833 100 50C100 56.8333 98.6875 63.2917 96.0625 69.375C93.4375 75.4583 89.875 80.7708 85.375 85.3125C80.875 89.8542 75.5833 93.4375 69.5 96.0625C63.4167 98.6875 56.9167 100 50 100ZM50 92.5C61.8333 92.5 71.875 88.3542 80.125 80.0625C88.375 71.7708 92.5 61.75 92.5 50C92.5 38.1667 88.375 28.125 80.125 19.875C71.875 11.625 61.8333 7.5 50 7.5C38.25 7.5 28.2292 11.625 19.9375 19.875C11.6458 28.125 7.5 38.1667 7.5 50C7.5 61.75 11.6458 71.7708 19.9375 80.0625C28.2292 88.3542 38.25 92.5 50 92.5Z",
    fill: "white"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vimeo_player = _resolveComponent("vimeo-player")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showPlayIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(_component_vimeo_player, {
      ref: "player",
      "video-id": _ctx.videoId,
      onPlay: _ctx.onPlay,
      onReady: _ctx.onReady
    }, null, 8, ["video-id", "onPlay", "onReady"])
  ]))
}